<app-user-bar></app-user-bar>

<div class="container px-0">
  <div class="it-nav-wrapper py-3 py-lg-0">
    <div class="it-header-center-wrapper custom-header">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="it-header-center-content-wrapper p-0">
              <div class="it-brand-wrapper">
                <a
                  [attr.title]="'BCK_HOME' | translate"
                  [routerLink]="!isUserLogged ? '/' : '/servizi'"
                >
                  <img
                    [alt]="'ALT_LOGO_SIU_HEADER' | translate"
                    class="logo-cap"
                    src="../../../assets/Logo_SIUf.svg"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="col mt-4">
            <div class="d-none d-lg-flex justify-content-end gap-5">
              <span class="follow-us">{{ "FOLLOW_US" | translate }}</span>
              <a
                target="_blank"
                [attr.title]="'FACEBOOK_EXT' | translate"
                [href]="'https://www.facebook.com/RegAbruzzo'"
              >
                <img
                  [alt]="'ALT_LOGO_FACEBOOK' | translate"
                  src="../../../assets/facebook-logo.svg"
                />
              </a>
              <a
                target="_blank"
                [attr.title]="'TWITTER_EXT' | translate"
                [href]="'https://twitter.com/regione_abruzzo'"
              >
                <img
                  [alt]="'ALT_LOGO_TWITTER' | translate"
                  src="../../../assets/X-icon-blue.svg"
                />
              </a>
              <a
                target="_blank"
                [attr.title]="'YOUTUBE_EXT' | translate"
                [href]="'https://www.youtube.com/user/WebtvRegioneAbruzzo'"
              >
                <img
                  [alt]="'ALT_LOGO_YOUTUBE' | translate"
                  src="../../../assets/youtube-logo.svg"
                />
              </a>
              <a
                target="_blank"
                [attr.title]="'VIMEO_EXT' | translate"
                [href]="'https://vimeo.com/user107766982'"
              >
                <img
                  [alt]="'ALT_LOGO_VIMEO' | translate"
                  src="../../../assets/vimeo-logo.svg"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-navbar></app-navbar>
  </div>
</div>
